import "jquery-import"
import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";

import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";
import Page from "webPage/Page";
import PageAnimations from "webPage/PageAnimations";
import {handleStickyNav} from "util/stickyNav";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    $('body').on('click', '.js-toggle-navigation', function(){
        $('body').toggleClass('nav-active');

        return false;
    }).on('click', '.js-dropdown-toggle', function(){
        let $navigation_item = $(this).parent('.navigation__item');
        $navigation_item.find('.dropdown').stop().slideToggle();
        setTimeout(() => {
            $navigation_item.toggleClass('navigation__item--dropdown-active');
        });
    });

    svg4everybody();
    PageAnimations.start();
    Page.init();
    handleStickyNav();

    //calcSVGPathLength($('.footer__3sk path'));

    appHeight();

});

function appHeight() {
    let doc = document.documentElement;
    doc.style.setProperty('--screen-height', $(window).innerHeight() + 'px');
}

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/3sk/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

export function calcSVGPathLength($el){
    console.log($el[0].getTotalLength());
}

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
